import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App.tsx";

const faviconUrl = process.env.REACT_APP_TAB_ICON_URL;
if (faviconUrl) {
  const favicon = document.getElementById("favicon");
  if (favicon) {
    favicon.href = faviconUrl;
  }
}

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
